module.exports = __webpack_public_path__ + "static/media/ticket-alt.ee260de0.svg";